/** @jsxImportSource @emotion/react */
import React from 'react'

interface SendToMobileIconProps {
  size?: number
  color?: string
  className?: string
}

const SendToMobileIcon: React.FC<SendToMobileIconProps> = ({
  size = 16,
  color = 'white',
  className,
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
    className={className}
  >
    <path
      d='M10.4033 12H3.73665V4.00002H10.4033C10.4033 4.36669 10.7033 4.66669 11.07 4.66669C11.4367 4.66669 11.7367 4.36669 11.7367 4.00002V2.00002C11.7367 1.26669 11.1367 0.666687 10.4033 0.666687L3.73665 0.673354C3.00332 0.673354 2.40332 1.26669 2.40332 2.00002V14C2.40332 14.7334 3.00332 15.3334 3.73665 15.3334H10.4033C11.1367 15.3334 11.7367 14.7334 11.7367 14V12C11.7367 11.6334 11.4367 11.3334 11.07 11.3334C10.7033 11.3334 10.4033 11.6334 10.4033 12Z'
      fill={color}
    />
    <path
      d='M13.5033 7.76669L11.6433 5.90669C11.43 5.69335 11.07 5.84002 11.07 6.14002V7.33335H8.40332C8.03665 7.33335 7.73665 7.63335 7.73665 8.00002C7.73665 8.36669 8.03665 8.66669 8.40332 8.66669H11.07V9.86002C11.07 10.16 11.43 10.3067 11.6367 10.0934L13.4967 8.23335C13.63 8.10669 13.63 7.89335 13.5033 7.76669Z'
      fill={color}
    />
  </svg>
)

export default SendToMobileIcon
